import { Model } from '@models/model';
import { Paginated } from '@models/paginated';

export class SmsAdvList extends Paginated {
  data: Array<SmsAdv>;
}

export class SmsAdv extends Model {
  idSmsAdvCampaign: number;
  title: string;
  createDate: string;
  message: string;
  recipientCriteria: RecipientCriteria;
  countRecipients: number;
  limitRecipients: number;
  fragmentsCount: number;
  sender: SenderSmsAdv;
  status: string;
  sendingType: string;
  scheduledDate: string;
  idPage: number;
}

export class SenderSmsAdv extends Model {
  idSender: number;
  valueSender: string;
}

export class RecipientCriteria extends Model {
  ageRanges: string[];
  regions: Region[];
  provinces: Province[];
  zipCodes: ZipCodes[];
  genders: string[];
}

export class Region extends Model {
  region: number;
  name: string;
}

export class Province extends Model {
  region: number;
  abbreviation: string;
  extendedName: string;
}

export class ZipCodes extends Model {
  zipCode: number;
  region: number;
  province: string;
}

export enum SmsAdvCampaignStatus {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  SCHEDULED = 'SCHEDULED',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  SENDING = 'SENDING',
  ARCHIVED = 'ARCHIVED'
}

export enum SmsAdvCampaignStatusHTMLSpanDraw {
  SENT = '<span class="badge badge-sent">',
  ERROR = '<span class="badge badge-error">',
  DRAFT = '<span class="badge badge-email-draft">',
  SCHEDULED = '<span class="badge badge-email-scheduled">'
}

export enum SmsAdvLabel {
  SUMMARY_GENDERS = 'smsadv_summary_settings_recipients_gender_',
  SUMMARY_SEND_TYPE = 'smsadv_summary_settings_config_sendtype_'
}

export enum SmsAdvFields {
  FIELD_CRITERIA = 'recipientCriteria',
  FIELD_SENDING_TYPE = 'sendingType',
  FIELD_SCHEDULED_DATE = 'scheduledDate'
}

export enum SmsAdvCriteriaFields {
  FIELD_GENDERS = 'genders',
  FIELD_AGE_RANGES = 'ageRanges',
  FIELD_REGIONS = 'regions',
  FIELDS_PROVINCES = 'provinces',
  FIELD_ZIP_CODES = 'zipCodes'
}
